"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var PeerConnectionUtils = {};
/**
 * Convert C line to IPv4
 * @param {String} sdp
 * @returns {String}
 */

PeerConnectionUtils.convertCLineToIpv4 = function (sdp) {
  var replaceSdp = sdp; // TODO: remove this once linus supports Ipv6 c line.currently linus rejects SDP with c line having ipv6 candidates we are
  // mocking ipv6 to ipv4 candidates
  // https://jira-eng-gpk2.cisco.com/jira/browse/SPARK-299232

  replaceSdp = replaceSdp.replace(/c=IN IP6 .*/gi, 'c=IN IP4 0.0.0.0');
  return replaceSdp;
};

var _default = PeerConnectionUtils;
exports.default = _default;
//# sourceMappingURL=util.js.map
